import {apiWeb} from './api';
import webApi from "./redux/apis/webApi";

function postWebApi(endPoint) {
    return webApi.post(endPoint)
        .then(res => {
            return res.data
        })
        .catch(err => {
            if (err.response) {
                // Server responded with a status other than 200 range

                if (err.response.status === 404) {
                    alert('Error: Page Not Found');
                }
            } else if (err.request) {
                // Request was made but no response
                console.error(err.request);
            } else {
                console.error(err.message);
            }
        });
}


function postWebApiWithBody(endPoint, body) {
    return webApi.post(endPoint, body)
        .then(res => {
            return res.data
        })
        .catch(err => {
            console.log(err)
            if (err.response) {
                // Server responded with a status other than 200 range
                console.log(err.response.data);
                console.log(err.response.status);
                console.log(err.response.headers);

                if (err.response.status === 404) {
                    alert('Error: Page Not Found');
                } else if (err.response.status === 400) {
                    return err.response.data.errors.errorMessage;
                }
            } else if (err.request) {
                // Request was made but no response
                console.error(err.request);
            } else {
                console.error(err.message);
            }
        });
}

const getWebApi = async (endPoint) => {
    return webApi.get(endPoint)
        .then(res => {
            return res.data
        })
        .catch(err => {
            if (err.response) {
                // Server responded with a status other than 200 range
                console.log(err.response.data);
                console.log(err.response.status);
                console.log(err.response.headers);
                if (err.response.status === 404) {
                    alert('Error: Page Not Found');
                }
            } else if (err.request) {
                // Request was made but no response
                console.error(err.request);
            } else {
                console.error(err.message);
            }
        });
};


export default {
    postWebApi,
    postWebApiWithBody,
    getWebApi
}